import { render, staticRenderFns } from "./Egea.vue?vue&type=template&id=4f02523a&"
import script from "./Egea.vue?vue&type=script&lang=js&"
export * from "./Egea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports